import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { LocalStoreManager, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SaleItemFormComponent } from "../sale-item-form/sale-item-form.component";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { Goods } from "src/app/backoffice/inv/models/goods.model";
import { take } from "rxjs/operators";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";

@Component({
  selector: "ngx-sale-item-list",
  templateUrl: "./sale-item-list.component.html",
  styleUrls: ["./sale-item-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaleItemListComponent extends BaseListComponent {
  @ViewChild("grid") grid: KGridComponent;
  columns: form_control[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public storage: LocalStoreManager) {
    super();
    this.inputEditorform = SaleItemFormComponent;
  }

  ngOnInit(): void {
    this.apiName = "";
    this.areaName = "RestaurantSale";
    this.setHeaderColumns();
  }

  setHeaderColumns() {
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.ItemCode"),
      controlType: FormControlTypes.textbox,
      modelName: "Code",
      textType: "text",
      disabled: false,
      name: "Code",
      order: 0,
      formVisible: false,
      listVisible: true,
      required: true,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.Title"),
      controlType: FormControlTypes.textbox,
      modelName: "Title",
      disabled: false,
      name: "Title",
      textType: "text",
      order: 1,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.MeasurementUnit"),
      controlType: FormControlTypes.textbox,
      modelName: "UnitTitle",
      disabled: false,
      name: "UnitTitle",
      textType: "text",
      order: 2,
      formVisible: true,
      listVisible: true,
      required: false,
    });
  }

  deleteGoods(row: Goods) {
    let message = `${this.translate("ClientApp.FrontOffice.Inv.SaleFormula.SureToDeleteData")}`;
    this.sts.showDialog(message, this.translate("ClientApp.FrontOffice.Inv.SaleFormula.DeleteInformation"), DialogType.confirm, () =>
      this.remove(row.Id)
    );
  }

  remove(id: number) {
    this.httpCommonService
      .delete("SaleFormula/DeleteGoods", id)
      .pipe(take(1))
      .subscribe(
        (res) => {
          this.grid.refreshData();
        },
        (err) => {
          this.sts.showDialog(
            `${this.label}: ${Utilities.getHttpResponseMessage(err)}`,
            this.translate("ClientApp.FrontOffice.Inv.SaleFormula.ErrorRemovingProduct")
          );
        }
      );
  }
}
